WiseMetering.Views.ShowWiseJsonIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/wise_json/show',
    title: () => i18next.t('modal.title.integrations.show'),

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            configurationName: this.model.configuration().get('name'),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
